import React, { useEffect, useRef } from 'react';
import { Card, Button, Space, Input } from 'antd';
import { DeleteFilled } from '@ant-design/icons';
import DragHandle from 'components/DragHandle';
import CenterContent from 'components/CenterContent';
import RichTextInput from 'components/RichTextInput';
import { useSize } from 'ahooks';

const EditDashboardContent = ({ content, removeContent, removing, editedContent, setEditedContent, onSizeChange }) => {
  const cardRef = useRef();
  const size = useSize(cardRef);

  useEffect(() => {
    onSizeChange?.(content.id, size);
  }, [size, content.id, onSizeChange]);
  return (
    <Card
      className="dashboard__content"
      title={(
        <Space>
          <DragHandle />
          <Input style={{ width: 350 }} value={editedContent.title} onChange={(e) => setEditedContent({ title: e.target.value })} />
        </Space>
    )}
      extra={(
        <Button
          danger
          loading={removing}
          icon={<DeleteFilled />}
          onClick={removeContent}
        />
      )}
      ref={cardRef}
    >
      <div style={{ padding: 16 }}>
        <RichTextInput
          value={editedContent.richText}
          onChange={value => setEditedContent({ richText: value })}
          placeholder="Enter your text content here..."
        />
        <CenterContent style={{ marginTop: 16 }}>Move content by dragging it from the top left corner. Resize by dragging from the right edge.</CenterContent>
      </div>
    </Card>
  );
};

export default EditDashboardContent;
